import { ArrowDownIcon } from "@heroicons/react/outline";
import React, { useEffect, useState } from "react";

type ButtonScrollProps = {
  className?: string;
  onClick?: () => void;
};

const ButtonScroll = ({ className, onClick }: ButtonScrollProps) => {
  const [top, setTop] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 100) {
          setTop(true);
        } else {
          setTop(false);
        }
      });
    };
    onScroll();
    return window.removeEventListener("scroll", () => setTop(top));
  });
  return (
    <div
      className={`fixed hidden xl:flex justify-center bottom-8 w-full ${className}`}
    >
      <button
        className={`flex z-[40] px-3 animate-bounce py-1 rounded-full items-center justify-center bg-gray-500 bg-opacity-30 ${
          top && "hidden lg:hidden"
        }`}
        onClick={onClick}
      >
        Scroll
        <ArrowDownIcon className="w-4 h-4"></ArrowDownIcon>
      </button>
    </div>
  );
};

export default ButtonScroll;
